import { useState } from "react";
import { LocationListing, type LocationListingSearchParams } from "@/components/locations";

const DEFAULT_PARAMS: LocationListingSearchParams = {
  page: 1,
  pageSize: 50,
  status: "all",
};

export function RegionLocationsTab({ regionId }: { regionId: number }) {
  const [searchParams, setSearchParams] = useState<LocationListingSearchParams>(DEFAULT_PARAMS);

  return (
    <LocationListing
      regionId={regionId}
      searchParams={searchParams}
      onNavigate={(updater) => setSearchParams((prev) => updater(prev))}
    />
  );
}
